<template>
  <a-modal
    title="选择生成的合同号"
    :width="480"
    :visible="visible"
    :confirmLoading="loading"
    @ok="this.ok"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <a-row :gutter="[16,16]">
          <a-col :span="24">
            <a-form-item label="合同号">
              <a-radio-group
                v-decorator="[
                  'contract_number',
                  {
                    rules: [
                      { required: true, message: '选择合同号' },
                    ],
                  },
                ]">
                <a-radio style="display: block; height: 40px; lineHeight: 40px" :value="item.contract_number" v-for="item in contractNumberList" :key="item.contract_number">
                  {{ item['contract_number'] }} ({{item['department_name']}})
                </a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 }
      }
    }
    return {
      contractNumberList: [],
      currentComponent: '',
      visibleFrom: false,
      confirmLoadingFrom: false,
      mdl: {},
      form: this.$form.createForm(this)
    }
  },
  mounted () {
    if (this.model) {
      this.contractNumberList = this.model['list']
    }
  },
  methods: {
    ok () {
      this.$emit('ok')
    }
  }
}
</script>
